export default __webpack_public_path__ + "static/media/bou.19ce493e.svg";